export default __webpack_public_path__ + "static/media/040-gift.4724dab4.svg";